import React from 'react';
import { InputNumber } from 'antd';

export const snapToStep = (value, step, min, max) => {
  if (value == null) return value;
  let result = Math.round(value / step) * step;
  if (min != null) result = Math.max(min, result);
  if (max != null) result = Math.min(max, result);
  return result;
};

export default React.forwardRef(
  (props, ref) => <InputNumber className='OnTraccrNumberInput' ref={ref} {...props} />
);
